import { fetchers } from '@pes-ui/utils';

export class SubstitutionProductsAPI {
  constructor({ countryCode, languageCode }) {
    this.countryCode = countryCode;
    this.languageCode = languageCode;
  }
 getSubstitutionProducts = async (ids) => {
    const queryParam = this.parseToQuery(ids);
    
    if(!queryParam) 
      return { 
        error: new Error("Can't load substitions"), 
        productSubstitutionsResponse: null 
      };
    
    return fetchers.getSubstitutionProducts({
      params: { productids: queryParam },
      countryCode: this.countryCode,
      languageCode: this.languageCode,
    });
  };

  parseToQuery(param) {
    let queryParam = null;

    if (Array.isArray(param)) {
      queryParam = param.map((id) => id).join(',');
    } else if (typeof param === 'string') {
      queryParam = param;
    }

    return queryParam;
  }
}
